import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EMessagesActionTypes } from './types';

export const updateMessagesCount = actionGenerator<EMessagesActionTypes.UpdateCount, number>(
  EMessagesActionTypes.UpdateCount,
);
